import { TaskHeaderBar } from '@repo/ccc-queue-app-lib/src/lib/TaskHeaderBar/TaskHeaderBar.tsx'
import { TaskPageLayoutUi } from '@repo/ccc-queue-app-lib/src/lib/TaskPageLayoutUi.tsx'
import {
  TakeNewTaskPage,
  type TakeNewTaskPageProps,
} from '@repo/ccc-queue-app-lib/src/pages/TakeNewTaskPage/TakeNewTaskPage.tsx'
import { CLAIM_QUEUE_TASK_TYPE_ARRAY } from '@repo/internal-tools-api/src/services/queues/ClaimQueueTaskByGroupService.ts'
import { createFileRoute } from '@tanstack/react-router'
import * as v from 'valibot'

const DEFAULT_ROUTING_GROUP: TakeNewTaskPageProps['routingGroup'] = 'All'
const DEFAULT_TASK_TYPES: TakeNewTaskPageProps['taskTypes'] = ['Unknown']

const NEW_TASK_SEARCH_PARAMS_SCHEMA = v.object({
  routingGroup: v.optional(
    v.fallback(v.string(), DEFAULT_ROUTING_GROUP),
    DEFAULT_ROUTING_GROUP,
  ),
  taskTypes: v.optional(
    v.fallback(
      v.array(v.picklist(CLAIM_QUEUE_TASK_TYPE_ARRAY)),
      DEFAULT_TASK_TYPES,
    ),
    DEFAULT_TASK_TYPES,
  ),
})

export const Route = createFileRoute('/_authenticated/take-new-task')({
  validateSearch: NEW_TASK_SEARCH_PARAMS_SCHEMA,
  component: TakeNewTaskRoute,
})

function TakeNewTaskRoute() {
  const { routingGroup, taskTypes } = Route.useSearch()

  return (
    <TaskPageLayoutUi>
      <TaskHeaderBar />
      <TakeNewTaskPage routingGroup={routingGroup} taskTypes={taskTypes} />
    </TaskPageLayoutUi>
  )
}
